// On garde un registre des écouteurs actifs
let activeListeners = new Map();

function clearInpErrors() {
    // Supprime les messages d’erreur
    document.querySelectorAll('.input-error').forEach(err => err.remove());
    // Supprime les classes d’erreur
    document.querySelectorAll('input.border-red-500, textarea.border-red-500, select.border-red-500')
        .forEach(inp => inp.classList.remove('border-red-500', 'border-2'));
    // Supprime tous les anciens écouteurs
    activeListeners.forEach((listener, input) => input.removeEventListener('input', listener));
    activeListeners.clear();
}

function showInpError(input, validateFunc, ...messages) {
    if (!input) return;

    // Supprime éventuelle erreur
    const existingError = input.parentNode.querySelector('.input-error');
    if (existingError) existingError.remove();

    // Ajoute styles + messages
    input.classList.add('border-2', 'border-red-500');
    const errorDiv = document.createElement('div');
    errorDiv.className = 'input-error text-red-600 text-sm mt-1';
    messages.forEach(msg => {
        const p = document.createElement('p');
        p.textContent = msg;
        errorDiv.appendChild(p);
    });
    input.parentNode.insertBefore(errorDiv, input.nextSibling);

    // Ajoute le listener de correction si pas déjà présent
    if (!activeListeners.has(input)) {
        const listener = () => {
            const errors = validateFunc(input); // ← ICI : on récup le tableau
            const stillInvalid = Array.isArray(errors) ? errors.length > 0 : !!errors;

            if (!stillInvalid) {
                // on retire l'erreur
                const err = input.parentNode.querySelector('.input-error');
                if (err) err.remove();
                input.classList.remove('border-red-500', 'border-2');
                // on retire le listener
                input.removeEventListener('input', listener);
                activeListeners.delete(input);
            } else {
                // optionnel: re-afficher le bon message si l'erreur change
                const err = input.parentNode.querySelector('.input-error');
                if (err) {
                    err.innerHTML = '';
                    errors.forEach(msg => {
                        const p = document.createElement('p');
                        p.textContent = msg;
                        err.appendChild(p);
                    });
                }
            }
        };
        input.addEventListener('input', listener);
        activeListeners.set(input, listener);
    }
}

/** Vérifie la validité d’un SIRET (clé Luhn) */
function isValidSiret(siret) {
    if (!/^\d{14}$/.test(siret)) return false;
    let sum = 0;
    for (let i = 0; i < 14; i++) {
        let num = parseInt(siret.charAt(i), 10);
        if (i % 2 === 0) num *= 2;
        if (num > 9) num -= 9;
        sum += num;
    }
    return sum % 10 === 0;
}

/** Vérifie un téléphone français */
function isValidFrenchPhone(tel) {
    const cleaned = tel.replace(/\s+/g, '');
    return /^(?:(?:\+33|0)[1-9])(?:\d{8})$/.test(cleaned);
}

/** Vérifie un code postal français */
function isValidPostalCode(code) {
    return /^\d{5}$/.test(code);
}

/**
 * Valide une liste d'inputs
 */
function validateInputs(validations) {
    // on repart propre
    clearInpErrors();
    let hasError = false;

    validations.forEach(rule => {
        const [id, rulesStr] = rule.split(':');
        const input = document.getElementById(id);
        if (!input) return;

        const value = (input.value || '').trim();
        const rules = (rulesStr || '').split('|');

        const hasNullable = rules.includes('nullable');
        const hasRequired = rules.includes('required');

        // nullable + vide → on skip
        if (hasNullable && !value) {
            return;
        }

        // required + vide → on affiche juste ça et on écoute
        if (hasRequired && !value) {
            showInpError(
                input,
                // on passe une fonction de revalidation juste pour cet input
                (el) => validateSingle(rules, el),
                'Ce champ est obligatoire'
            );
            hasError = true;
            return;
        }

        // sinon on valide tout
        const errs = validateSingle(rules, input);
        if (errs.length) {
            showInpError(
                input,
                (el) => validateSingle(rules, el),
                ...errs
            );
            hasError = true;
        }
    });

    return !hasError;
}

/**
 * Valide un seul input avec ses règles, renvoie un tableau d'erreurs
 */
function validateSingle(rules, input) {
    const value = (input.value || '').trim();
    const errors = [];

    rules.forEach(r => {
        if (r.startsWith('min=')) {
            const min = parseInt(r.split('=')[1], 10);
            if (value.length < min) errors.push(`Minimum ${min} caractères`);
        } else if (r.startsWith('max=')) {
            const max = parseInt(r.split('=')[1], 10);
            if (value.length > max) errors.push(`Maximum ${max} caractères`);
        } else if (r === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) errors.push('Adresse e-mail invalide');
        } else if (r === 'siret') {
            if (!isValidSiret(value)) errors.push('Numéro SIRET invalide');
        } else if (r === 'tel') {
            if (!isValidFrenchPhone(value)) errors.push('Numéro de téléphone invalide');
        } else if (r === 'postal') {
            if (!isValidPostalCode(value)) errors.push('Code postal invalide');
        }
    });

    return errors;
}

export default Object.assign(validateInputs, { clear: clearInpErrors });
